// Hardcoded values to replace the options system
// Only Model selection remains as a configurable option

export const HARDCODED_VALUES = {
  // Discord Community
  discord: {
    inviteLink: 'https://discord.gg/jYaUrvMP2Z',
  },
  // Chat Parameters - only model remains configurable
  parameters: {
    temperature: 0.3,
  },

  // TTS functionality removed

  // Auto-scroll Options
  autoScroll: {
    autoScrollWhenOpeningChat: true,
    autoScrollWhileGenerating: false,
  },

  // Input Options
  input: {
    submitOnEnter: true,
  },

  // Markdown Options
  markdown: {
    katex: false,
  },

  // Speech Recognition / Whisper Options
  speechRecognition: {
    useWhisper: false,
    showMicrophone: false,
  },

  // Context Trimmer Plugin Options
  contextTrimmer: {
    maxTokens: 10000,
    preserveSystemPrompt: true,
  },

  // System Prompt Plugin Options - now handled server-side
  systemPrompt: {
    // System prompt is now injected server-side for security
  },

  // Quick Settings removed
} as const;

// Helper functions to get hardcoded values
export function getHardcodedValue(category: keyof typeof HARDCODED_VALUES, key: string): any {
  const categoryValues = HARDCODED_VALUES[category] as any;
  return categoryValues?.[key];
}

// Type definitions for better type safety
export type HardcodedValueCategory = keyof typeof HARDCODED_VALUES;
export type DiscordValues = typeof HARDCODED_VALUES.discord;
export type ParametersValues = typeof HARDCODED_VALUES.parameters;
// TTS functionality removed
export type AutoScrollValues = typeof HARDCODED_VALUES.autoScroll;
export type InputValues = typeof HARDCODED_VALUES.input;
export type MarkdownValues = typeof HARDCODED_VALUES.markdown;
export type SpeechRecognitionValues = typeof HARDCODED_VALUES.speechRecognition;
export type ContextTrimmerValues = typeof HARDCODED_VALUES.contextTrimmer;
export type SystemPromptValues = typeof HARDCODED_VALUES.systemPrompt; 